<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别集">
              <global-select
                :value.sync="queryParams.categorySetId"
                requestApi="/mdm/itemCategorySet/pullDownList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ organizationId: organizationCodeOrigin }"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码" class="itemcode">
              <a-input v-model="queryParams.itemCode" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别">
              <a-input v-model="queryParams.categoryDesc" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemApportionNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:itemApportion:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:itemApportion:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1500 }"
          @successCallBack="successCallBack"
        >
          <template slot="itemCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.itemCode }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.itemCode"
              selectType="selectSearch"
              requestApi="/mdm/itemApportion/itemMessage"
              :selectItem="{ value: 'itemCode', label: 'itemCode' }"
              searchParam="itemCode"
              size="small"
              @change="(val, list) => itemCodeOnChange(val, list, record)"
            />
          </template>
          <template slot="categoryDesc" slot-scope="{ record, index }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.categoryDesc }}</span>
            <a-cascader
              v-if="isEdit && currentId === record.id"
              v-model="record.categoryCodeNew"
              :field-names="{ label: 'name', value: 'code', children: 'segmentVOs' }"
              :options="categoryDescList"
              expand-trigger="hover"
              placeholder=""
              size="small"
              @change="(val) => categoryCodeChange(val, record, index)"
            />
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:itemApportion:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" class="ml10" v-hasPermi="['mdm:itemApportion:remove']">删除</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 创建/编辑快码,单独封装了组件 -->
        <material-category-distribution-add
          ref="createModal"
          :categorySetId="queryParams.categorySetId"
          :categoryDescList="categoryDescList"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemApportionList, apiItemApportionEdit, apiItemApportionDelete, apiItemCategoryCodePullDownList, apiMdmItemApportionNewExport } from '@/api/mdm/matter/material-category'
import MaterialCategoryDistributionAdd from './components/material-category-distribution-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'material-category-distribution',
  components: {
    DownloadModal,
    MaterialCategoryDistributionAdd
  },
  data () {
    return {
      apiMdmItemApportionNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiItemApportionList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        categorySetId: undefined,
        itemCode: undefined,
        // itemCodeStart: undefined,
        // itemCodeEnd: undefined,
        categoryDesc: undefined
      },
      // 快码表格数据
      typeList: [],
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          align: 'center',
          width: 170
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类别代码',
          dataIndex: 'categoryCode',
          align: 'center'
        },
        {
          title: '类别',
          dataIndex: 'categoryDesc',
          scopedSlots: { customRender: 'categoryDesc' },
          ellipsis: true,
          align: 'center',
          width: 180
        },
        {
          title: '最后修改人',
          dataIndex: 'updateBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 170,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 170,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      categoryDescList: [] // 类别
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.queryParams.categorySetId = this.$route.query && this.$route.query.id || null;
    this.handleQuery()
    this.getPullDownCodeList()
  },
  mounted () {},
  methods: {
    // 列表-类别
    categoryCodeChange (val, record, index) {
      const tableList = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      tableList[index].categoryCode = val && val.join(".") || ""
      this.$refs.dataTable.myDataSource = tableList
    },
    // 接口请求成功后回调
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      for (let i = 0; i < tableList.length; i++) {
        tableList[i].categoryCodeNew = tableList[i].categoryCode && tableList[i].categoryCode.split(".")
      }
      this.$refs.dataTable.myDataSource = tableList
    },
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 物料编码
    itemCodeOnChange (val, list, record) {
      const itemSelect = list.find(item => {
        return item.itemCode === val
      })
      record.description = itemSelect && itemSelect.specification || ""
      record.attributeId = itemSelect && itemSelect.itemCode || ""
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const dictId = row.id
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 id为${dictId}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiItemApportionDelete(dictId).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.handleQuery()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.itemCode) {
        this.$message.warning('物料编码不能为空')
        return
      }
      if (!record.categoryCode) {
        this.$message.warning('类别不能为空')
        return
      }
      apiItemApportionEdit(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.handleQuery()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.handleQuery()
    },
    // 类别代码-下拉框
    getPullDownCodeList () {
      apiItemCategoryCodePullDownList({ categorySetId: this.queryParams.categorySetId }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.categoryDescList = res.data
        }
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/itemApportion/export', {
      //   ...this.queryParams
      // }, `物料类别分配_${new Date().getTime()}.xlsx`)
    },
    // 新增/修改框事件
    handleOk () {
      this.handleQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        categorySetId: this.$route.query && this.$route.query.id || null,
        itemCode: undefined,
        // itemCodeStart: undefined,
        // itemCodeEnd: undefined,
        categoryDesc: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  /deep/.ant-select{
    width: 140px;
  }
  /deep/.ant-cascader-input{
    width: 140px;
  }
}
.itemcode{
  /deep/.ant-input-group.ant-input-group-compact > *{
    width: 50%;
  }
}
</style>
